import { apiFetch } from '../../utils/requests';
import { verifySegmentationURL } from '../../settings/api';
import addNewSegmentation from './addNewSegmentation';

export default function verifySegmentation(segID, scanDate) {
  return dispatch => {
    const body = scanDate ? { scanDate } : {};

    return apiFetch(verifySegmentationURL(segID), localStorage.getItem('token'), 'POST', body).then(
      seg => {
        dispatch(addNewSegmentation(seg));
      },
    );
  };
}
